<template>
  <div class='lt-fyf-disclaimer-and-assumptions-page'>
    <div class='lt-fyf-disclaimer-and-assumptions-page_top-border'>
      Disclaimer and Assumptions
    </div>
    <div class='lt-fyf-disclaimer-and-assumptions-page_content'>
      <button class='lt-fyf-disclaimer-and-assumptions-page_close-btn' @click="goToLastVisitedPage()">
        &times;
      </button>
      <RenderTemplate :string="copy.disclaimer" />
      <RenderTemplate :string="copy.assumptions" />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  computed: {
    copy() {
      return {
        disclaimer: `
          <h2 class='lt-fyf-disclaimer-and-assumptions-page_disclaimer-header'>
            Disclaimer
          </h2>
          <p>This calculator provides an illustration of your target expenditure in retirement and the amount of income you’ll need to meet this target. The totals are calculated based on the data you input and can only be as accurate as the information provided.</p>
          <p>Please remember that the results shown by the modeller are for illustrative purposes only and do not guarantee any future outcome or entitlement.</p>
          <p>You should also remember that you will need to pay income tax and the retirement target figure is based on your expenditure, not your pre-tax income.</p>
          <p>Any choices you make or data that you enter while using the calculator are erased once you have finished using the calculator. However, you have a responsibility to ensure that you exit the website when you have finished with the calculator, especially if you leave your computer for any length of time.</p>
        `,
        assumptions: `
          <h2 class='lt-fyf-disclaimer-and-assumptions-page_disclaimer-header'>
            Assumptions
          </h2>
          <p>Your target expenditure calculation is based on research conducted by Loughborough University and the Pensions and Lifetime Savings Association (PLSA). The research sets out three ‘Retirement Living Standards’ (Minimum, Moderate and Comfortable) which are based upon a basket of goods and services. You can find out more about the research and each of the Standards at <a href='https://www.retirementlivingstandards.org.uk/details'>www.retirementlivingstandards.org.uk/details</a>.</p>
          <p>Your target expenditure figure assumes you will have no rent or mortgage costs to pay in retirement and will be living outside London. </p>
          <p>Your monthly savings figure is based on the following assumptions: </p>
          <ul>
            <li>If you selected that you live with a partner, this is your total ‘household’ savings amount and assumes you and your partner are the same age and will both retire at the same age. Income tax has been applied based on you and your partner providing half the income amount each. </li>
            <li>It will provide you with a fixed level of retirement income over a 20-year period.</li>
            <li>You (and your partner if applicable) will be entitled to the full State Pension of £9,627.80. For the purposes of the calculation, the calculator assumes your State Pension will come into payment from your selected retirement age. To see when you’ll be eligible to receive the State Pension, visit <a href='https://www.gov.uk/state-pension-age'>www.gov.uk/state-pension-age</a> </li>
            <li>All figures and current tax rates are in today’s terms to take into account the effect of inflation.</li>
          </ul>`
      }
    }
  },
  methods: {
    ...mapMutations([
      'goToLastVisitedPage',
    ]),
  },
}
</script>

<style lang="scss">
.lt-fyf-disclaimer-and-assumptions-page {
  flex: 1 1 1px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.lt-fyf-disclaimer-and-assumptions-page_content {
  text-align: left;
  background: $disc-and-assumtpts-bg-color;
  color: $disc-and-assumtpts-color;
  margin: 0.5rem 1rem;
  padding: 2rem;
  font-size: 1.5rem;
  border-radius: 3px;
  font-size: 1rem;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}

.lt-fyf-disclaimer-and-assumptions-page_close-btn {
  position: absolute;
  color: $header-color-1;
  top: 0;
  right: 0;
  font-size: 3rem;
  width: 4rem;
  height: 4rem;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lt-fyf-disclaimer-and-assumptions-page_top-border {
  font-weight: normal;
  background: $main-background;
  color: $main-color;
  margin: 0.5rem 0;
  padding: 1rem;
  text-align: center;
  border-radius: 3px;
  font-size: 1rem;
  box-sizing: content-box;
  border-radius: 0.5rem;
}

.lt-fyf-disclaimer-and-assumptions-page_disclaimer-header,
.lt-fyf-disclaimer-and-assumptions-page_assumptions-header {
  color: $header-color-1;
}

.lt-fyf-disclaimer-and-assumptions-page_disclaimer-header {
  margin-top: 0;
}
</style>